import {
  EDITOR_ONBOARDING_PUMP_TOOLTIP_OPEN,
  EDITOR_ONBOARDING_SCENE_RELEASE,
} from './onboardingEvents';

let sceneEffectGeneration = 0;

/** Новая «сессия» эффектов шага scene-3d — отменяет отложенные OPEN. */
export function beginOnboardingSceneEffectGeneration() {
  sceneEffectGeneration += 1;
  return sceneEffectGeneration;
}

/** @param {number} generation */
export function isOnboardingSceneEffectCurrent(generation) {
  return generation === sceneEffectGeneration;
}

/** Инвалидирует все отложенные эффекты тура на 3D-сцене. */
export function invalidateOnboardingSceneEffects() {
  sceneEffectGeneration += 1;
}

/** Тур активен — только тогда разрешён программный OPEN тултипа насоса. */
export function setEditorOnboardingTourActive(active) {
  if (typeof window === 'undefined') {
    return;
  }
  window.__wellandEditorOnboardingTourActive = Boolean(active);
}

export function isEditorOnboardingTourActive() {
  return Boolean(
    typeof window !== 'undefined' && window.__wellandEditorOnboardingTourActive
  );
}

/** Демо-насос для шага «сцена» подмешан в 3D (можно открывать тултип). */
export function setEditorOnboardingSceneDemoReady(ready) {
  if (typeof window === 'undefined') {
    return;
  }
  window.__wellandEditorOnboardingSceneDemoReady = Boolean(ready);
}

export function isEditorOnboardingSceneDemoReady() {
  return Boolean(
    typeof window !== 'undefined' && window.__wellandEditorOnboardingSceneDemoReady
  );
}

/** Запрос открыть демо-тултип насоса (обрабатывает InstancedPumps). */
export function dispatchOnboardingPumpTooltipOpen() {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent(EDITOR_ONBOARDING_PUMP_TOOLTIP_OPEN));
}

/**
 * Полный сброс захвата сцены обучалкой: тултип, таймеры, флаг тура.
 * Режим камеры (бассейн / техпомещение / свободная) не меняется.
 */
export function releaseOnboardingSceneControl() {
  invalidateOnboardingSceneEffects();
  setEditorOnboardingTourActive(false);
  setEditorOnboardingSceneDemoReady(false);
  if (typeof window === 'undefined') {
    return;
  }
  // ВАЖНО: НЕ шлём PUMP_TOOLTIP_CLOSE (он звал closeStage → анимация выхода к
  // savedRef, ненадёжному в туре: камера застревала в приближении). SCENE_RELEASE
  // обрабатывает SmoothCameraController — жёсткий выход из stage (resetStage) +
  // плавный возврат камеры на ОБЫЧНЫЙ вид.
  window.dispatchEvent(new CustomEvent(EDITOR_ONBOARDING_SCENE_RELEASE));
}
